import React from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";


const Hero = () => {
  const { t } = useTranslation();

  // Data for the hero section
  const heroData = [
    {
      image: "assets/images/Home/project-img1.jpg",
      title: t('hero.1st-image-title'),
      description: t('hero.1st-image-desc'),
      buttonText: t('hero.1st-image-btn'),
    },
    {
      image: "assets/images/Home/project-img1.jpg",
      title: t('hero.2nd-image-title'),
      description: t('hero.2nd-image-desc'),
      buttonText: t('hero.2nd-image-btn'),
    },
    {
      image: "assets/images/Home/project-img2.jpg",
      title: t('hero.3rd-image-title'),
      description: t('hero.3rd-image-desc'),
      buttonText: t('hero.3rd-image-btn'),
    },
    {
      image: "assets/images/Home/project-img3.jpg",
      title: t('hero.4th-image-title'),
      description: t('hero.4th-image-desc'),
      buttonText: t('hero.4th-image-btn'),
    },
    {
      image: "assets/images/Home/project-img4.jpg",
      title: t('hero.5th-image-title'),
      description: t('hero.5th-image-desc'),
      buttonText: t('hero.5th-image-btn'),
    },
    {
      image: "assets/images/Home/project-img5.jpg",
      title: t('hero.6th-image-title'),
      description: t('hero.6th-image-desc'),
      buttonText: t('hero.6th-image-btn'),
    },
    {
      image: "assets/images/Home/project-img6.jpg",
      title: t('hero.7th-image-title'),
      description: t('hero.7th-image-desc'),
      buttonText: t('hero.7th-image-btn'),
    },
    {
      image: "assets/images/Home/project-img7.jpg",
      title: t('hero.8th-image-title'),
      description: t('hero.8th-image-desc'),
      buttonText: t('hero.8th-image-btn'),
    }
  ];
  

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 800, // Smooth transition speed
    // fade: true,  // Enable fade transition
    cssEase: "ease-in-out", // Smoother transition
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  

  return (
    <div className="min-h-screen overflow-hidden mt-12">
      <Slider {...settings}>
        {heroData.map((item, index) => (
          <div key={index} className="relative w-full">
            <div
              className="min-h-screen bg-cover bg-center w-full flex items-center justify-center" 
              style={{ backgroundImage: `url(${item.image})`, backgroundSize: "cover" }}
            >
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black opacity-70"></div>

              {/* Responsive text content on top of the overlay */}
              <div className="relative z-10 text-center text-neutral-content px-4 md:px-6 max-w-full mx-auto flex flex-col items-center justify-center">
                <div className="max-w-lg md:max-w-2xl lg:max-w-4xl text-fontcolor">
                  <h1 className="mb-5 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight drop-shadow-lg tracking-wide">
                    {item.title}
                  </h1>
                  <p className="mb-5 text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
                    {item.description}
                  </p>
                  <button className="bg-mstheme hover:bg-mstheme_hover text-fontcolor px-4 py-2 sm:px-6 sm:py-3 rounded-lg text-sm sm:text-base md:text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl">
                    {item.buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Hero;
